// extracted by mini-css-extract-plugin
export default {"item":"styles_item__zpOlf"};